import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Intro = () => {
  return (
    <Box margin={{ xs: "35% 0% 5% 0%", sm: "10% 0% 0% 0%" }}>
      <Typography
        variant="h4"
        color={"#39484E"}
        padding={{ xs: "5% 0% 0% 0%", sm: "0% 15% 0% 15%" }}
        textAlign={"center"}
        fontWeight={700}
      >
        The African Innovation and Resilience Fund (AIR Fund) is dedicated to
        empowering African communities by supporting transformative,
        community-driven projects.
      </Typography>
    </Box>
  );
};

export default Intro;
